import Cookies from 'js-cookie';

const isUseOhterApp = () => Cookies.get('client_use_other_app') === 'true';

export default isUseOhterApp();
